import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { Router } from '@angular/router';
import { from } from 'rxjs';
import { SharedDataService } from "./shared-data.service";
import { CacheService } from './cache/cache.service';
import { ReportDatesService } from './report-dates.service';

@Injectable({
    providedIn: 'root'
})
export class AuthServiceService {

    authBaseUrl: string;
    userPool = new CognitoUserPool(environment.userPool);

    private isOperator = new BehaviorSubject(false);
    isOperator$ = this.isOperator.asObservable();

    private isResident = new BehaviorSubject([]);
    isResident$ = this.isResident.asObservable();

    constructor(private http: HttpClient,
        private router: Router,
        private sharedDataService: SharedDataService,
        private cacheService: CacheService,
        private reportDatesService: ReportDatesService,
    ) {
        this.authBaseUrl = environment.environmentDetails + 'user-service/';
    }

    updateIsOperator(message: any) {
        this.isOperator.next(message);
    }

    updateIsResident(message: any) {
        this.isResident.next(message);
    }

    getUserData(): Observable<any> {
        return this.http.get(this.authBaseUrl + 'auth/getUserData' + '');
    }

    getUserVerified(): Observable<any> {
        return this.http.get(this.authBaseUrl + 'auth/setAuthContactVerified' + '');
    }

    getDepartments(): Observable<any> {
        return this.http.get(this.authBaseUrl + 'auth/getAllDepartments' + '');
    }

    sendVerificationCode(username: string): Observable<any> {
        return this.http.get(this.authBaseUrl + 'auth/forgotPassword?userName=' + username);
    }

    changePassword(data: any): Observable<any> {
        return this.http.post(this.authBaseUrl + 'auth/ConfirmResetPassword', data);
    }

    logoutUser(): void {
        const currentUser = this.userPool.getCurrentUser();
        if (currentUser) {
            this.userPool.getCurrentUser().signOut();
        }
        
        // Clear the return URL on explicit logout to prevent unintended redirects
        localStorage.removeItem('returnUrl');
        
        localStorage.clear();
        this.sharedDataService.setDispalyMissedComponent(false);
        this.sharedDataService.clearCachedData();

        // Clear API cache on logout
        this.cacheService.clear();

        // Clear reporting dates on logout
        this.reportDatesService.clearReportingDates();

        this.router.navigate(['login']);
    }

    getTokenForAPI(api) {
        let currentUser = this.userPool.getCurrentUser();
        if (!currentUser) {
            this.router.navigate(['login']);
        } else {
            return from(
                new Promise((resolve, reject) => {
                    currentUser.getSession((err, session) => {
                        if (err) {
                            reject(err);
                        } else if (!session.isValid()) {
                            resolve(null);
                        } else {
                            let accessToken = session.getAccessToken()
                            const expiresIn = accessToken.getExpiration() - Math.floor(new Date().getTime() / 1000);
                            if (api && environment.log_api_calls)
                                console.log('Exp: ' + expiresIn + 's (' + api + ')');
                            localStorage.setItem('token', accessToken.getJwtToken());
                            resolve(accessToken.getJwtToken())
                        }
                    });
                })
            );
        }
    }
}


